export default "__VITE_PUBLIC_ASSET__bff2245b__"